import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography
} from '@mui/material';

const ConfirmReplaceDialog = ({ open, date, onClose, onConfirm }) => (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Replace Quote?</DialogTitle>
      <DialogContent>
        <Typography>
          A quote already exists for {date}. Do you want to replace it?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={onConfirm}>Replace</Button>
      </DialogActions>
    </Dialog>
  );

export default ConfirmReplaceDialog;